import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

import type { DebugWorkflowModel } from './route';

export default class VisitorsInvitesDebugWorkflowController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  declare model: DebugWorkflowModel;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { WorkflowDebugPage } = await import('reactRichComponents/visitors/WorkflowDebugPage');
    if (this.isDestroying || this.isDestroyed) return;

    const { invite } = this.model;

    this.root = await this.reactRenderer.render(WorkflowDebugPage, 'react__workflow-debug-page', {
      inviteId: this.model.inviteId,
      visitor: invite
        ? {
            fullName: invite.fullName,
            email: invite.email,
            expectedArrivalTime: invite.expectedArrivalTime?.toISOString() ?? null,
            inviterName: invite.inviterName,
          }
        : null,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
